import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createLieu, type LieuDto } from "../api/lieuxApi";
import { queryKeys } from "../lib/queryKeys";

export function useCreateLieu() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: LieuDto) => createLieu(dto),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.lieux.all });
      qc.invalidateQueries({ queryKey: queryKeys.artists.all });
    },
  });
}
